import axios from '@/http/axios';

export default {
  fetchList: (config: any = {}) => {
    return axios.get(`/anzsco-occupations/`, config);
  },
  fetchRiskProfileTemplateList: (oid, config: any = {}) => {
    return axios.get(
      `/anzsco-occupations/${oid}/?expand[]=risk_profile_templates`,
      config
    );
  },
};
